/*
 * 1-Minute Maths
 * Copyright © 2021 - 2022 White Rose Maths
 * YesNoPad.tsx - Yes/No input
 */

import {
  TouchableOpacity, View, Text, StyleSheet
} from 'react-native';
import { RFPercentage } from 'react-native-responsive-fontsize';
import * as colours from '../../../colours';


interface YesNoPadProps {
  handleInputEvent(input: 'Yes' | 'No'): void;
  disabled: boolean
}

const YesNoPad = ({ handleInputEvent, disabled }: YesNoPadProps) => {
  return (
    <View style={styles.pad}>
      <TouchableOpacity
        key="Yes"
        style={styles.button}
        onPress={() => handleInputEvent('Yes')}
        disabled={disabled}>
        <Text style={styles.buttonText} allowFontScaling={false}>Yes</Text>
      </TouchableOpacity>

      <TouchableOpacity
        key="No"
        style={styles.button}
        onPress={() => handleInputEvent('No')}
        disabled={disabled}>
        <Text style={styles.buttonText} allowFontScaling={false}>No</Text>
      </TouchableOpacity>
    </View>
  );
};

export default YesNoPad;

const styles = StyleSheet.create({
  pad: {
    flexWrap: 'wrap',
    flexDirection: 'row',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },

  button: {
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    width: '33%',
    height:'100%',
  },

  buttonText: {
    color: '#575756',
    fontSize: RFPercentage(5),
    textAlign: 'center',
    fontFamily: 'WhiteRoseMathsFont',
  },

  confirmText: {
    color: colours.confirm
  },

  deleteText: {
    color: colours.backspace
  }

});
